import React from 'react';
import { TextField, Typography, Box } from '@material-ui/core';
import { useFormikContext } from 'formik';
import { PreferenceFormValues } from '../AdminConsoleCommunicationPreferences';
import { useCommonStyles } from '../commonStyles';

interface DefaultReplyToFormSectionProps {
  isLoading: boolean;
}

export const DefaultReplyToFormSection = ({ isLoading }: DefaultReplyToFormSectionProps) => {
  const { values, handleChange, errors, touched } = useFormikContext<PreferenceFormValues>();
  const classes = useCommonStyles();

  return (
    <Box>
      <Typography className={classes.sectionHeading} style={{ paddingTop: '1rem' }}>
        Reply-To Email
      </Typography>
      <Typography className={classes.sectionBody}>
        Set a reply-to email address for volunteer communications. If left blank, the system default will be used.
      </Typography>
      <TextField
        fullWidth
        variant='outlined'
        label='Reply-To Email'
        name='defaultReplyTo'
        value={values.defaultReplyTo}
        onChange={handleChange}
        error={touched.defaultReplyTo && Boolean(errors.defaultReplyTo)}
        helperText={touched.defaultReplyTo && errors.defaultReplyTo}
        disabled={isLoading}
        placeholder='support@yourorganization.com'
        type='email'
      />
    </Box>
  );
};
